import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";

export interface User<T = "verified" | "unverified"> {
  id: string;
  status: T;
  email: string;
  fullName: string;
  customerId: string;
  createdAt: string;
}

export type SubscribedUser = { type: "subscribed" } & { details: User<"subscribed"> };
export type VerifiedUser = { type: "verified" } & { details: User<"verified"> };
export type UnverifiedUser = { type: "unverified" } & { details: User<"unverified"> };
export type AnonymousUser = { type: "anonymous"; details: string };
export type UserDetails = SubscribedUser | VerifiedUser | UnverifiedUser | AnonymousUser;

export async function getUserDetails(): Promise<Response<UserDetails>> {
  const responseResult = await tryCatch(
    fetch(`${API_BASE_URL}/api/v1/usuarios/yo`, { credentials: "include" })
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err
      ? Err({
          message: `Error al obtener información del usuario: ${errorMessageResult.val.message}`,
          devMessage: errorMessageResult.val.message,
        })
      : Err({
          message: errorMessageResult.val.message,
          devMessage: errorMessageResult.val.devMessage,
        });
  }

  const dataResult = await tryCatch(response.json());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}
